import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";

export interface GetPostsApiParameter extends ApiParameter, HasPagingParameters {
    userId?: number;
    id?: number;
}

export interface PostModel {
    userId: number;
    id: number;
    title: string;
    categories: [];
}

export type PostsCollectionModel = PostModel[];

const postsApiUrl = "/api/v2/megamenucategories";

export function getPosts(parameter?: GetPostsApiParameter) {
    return get<PostsCollectionModel>(postsApiUrl, parameter);
}
